{
    "$id": "https://augmented.team/schemas/tools.frontmatter.v1.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TOOLS.md Frontmatter v1",
    "type": "object",
    "required": [
        "agent_id",
        "code_name",
        "version",
        "environment",
        "owner",
        "last_updated",
        "enforcement_mode",
        "global_controls",
        "tools"
    ],
    "properties": {
        "agent_id": {
            "type": "string",
            "minLength": 3,
            "maxLength": 128
        },
        "code_name": {
            "type": "string",
            "pattern": "^[a-z0-9]+(-[a-z0-9]+)*$"
        },
        "version": {
            "type": "string",
            "pattern": "^[0-9]+\\.[0-9]+(\\.[0-9]+)?$"
        },
        "environment": {
            "type": "string",
            "enum": [
                "dev",
                "stage",
                "prod"
            ]
        },
        "owner": {
            "type": "string",
            "minLength": 1,
            "maxLength": 128
        },
        "last_updated": {
            "type": "string",
            "format": "date"
        },
        "enforcement_mode": {
            "type": "string",
            "enum": [
                "wrapper",
                "gateway",
                "both"
            ]
        },
        "global_controls": {
            "type": "object",
            "required": [
                "default_network_policy",
                "default_timeout_ms",
                "default_rate_limit_rpm",
                "default_retries",
                "logging_redaction"
            ],
            "properties": {
                "default_network_policy": {
                    "type": "string",
                    "enum": [
                        "deny",
                        "allow"
                    ]
                },
                "default_timeout_ms": {
                    "type": "integer",
                    "minimum": 100,
                    "maximum": 120000
                },
                "default_rate_limit_rpm": {
                    "type": "integer",
                    "minimum": 1,
                    "maximum": 100000
                },
                "default_retries": {
                    "type": "integer",
                    "minimum": 0,
                    "maximum": 10
                },
                "logging_redaction": {
                    "type": "string",
                    "enum": [
                        "hash-only",
                        "redacted",
                        "full-local"
                    ]
                }
            },
            "additionalProperties": false
        },
        "tools": {
            "type": "array",
            "minItems": 0,
            "items": {
                "type": "object",
                "required": [
                    "id",
                    "name",
                    "type",
                    "access",
                    "enforcement",
                    "description",
                    "scope",
                    "limits",
                    "auth"
                ],
                "properties": {
                    "id": {
                        "type": "string",
                        "pattern": "^[a-z0-9]+(-[a-z0-9]+)*$"
                    },
                    "name": {
                        "type": "string",
                        "minLength": 2,
                        "maxLength": 128
                    },
                    "type": {
                        "type": "string",
                        "enum": [
                            "http",
                            "api",
                            "db",
                            "queue",
                            "filesystem",
                            "email",
                            "calendar",
                            "crm",
                            "custom"
                        ]
                    },
                    "access": {
                        "type": "string",
                        "enum": [
                            "read",
                            "write",
                            "admin"
                        ]
                    },
                    "enforcement": {
                        "type": "string",
                        "enum": [
                            "strict",
                            "best_effort"
                        ]
                    },
                    "description": {
                        "type": "string",
                        "minLength": 1,
                        "maxLength": 500
                    },
                    "scope": {
                        "type": "object",
                        "required": [
                            "resources",
                            "operations",
                            "constraints"
                        ],
                        "properties": {
                            "resources": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "minItems": 0
                            },
                            "operations": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "minItems": 0
                            },
                            "constraints": {
                                "type": "object"
                            }
                        },
                        "additionalProperties": false
                    },
                    "network": {
                        "type": "object",
                        "properties": {
                            "allowlist_domains": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "minItems": 0
                            },
                            "allowlist_paths": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "pattern": "^/"
                                },
                                "minItems": 0
                            },
                            "denylist_domains": {
                                "type": "array",
                                "items": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "minItems": 0
                            }
                        },
                        "additionalProperties": false
                    },
                    "limits": {
                        "type": "object",
                        "required": [
                            "timeout_ms",
                            "rate_limit_rpm",
                            "retries"
                        ],
                        "properties": {
                            "timeout_ms": {
                                "type": "integer",
                                "minimum": 100,
                                "maximum": 120000
                            },
                            "rate_limit_rpm": {
                                "type": "integer",
                                "minimum": 1,
                                "maximum": 100000
                            },
                            "retries": {
                                "type": "integer",
                                "minimum": 0,
                                "maximum": 10
                            },
                            "max_payload_kb": {
                                "type": "integer",
                                "minimum": 1,
                                "maximum": 102400
                            }
                        },
                        "additionalProperties": false
                    },
                    "auth": {
                        "type": "object",
                        "required": [
                            "method",
                            "secrets"
                        ],
                        "properties": {
                            "method": {
                                "type": "string",
                                "enum": [
                                    "oauth",
                                    "api_key",
                                    "jwt",
                                    "mtls",
                                    "none"
                                ]
                            },
                            "secrets": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    }
                },
                "additionalProperties": false,
                "allOf": [
                    {
                        "if": {
                            "properties": {
                                "type": {
                                    "const": "http"
                                }
                            }
                        },
                        "then": {
                            "required": [
                                "network"
                            ]
                        }
                    }
                ]
            }
        }
    },
    "additionalProperties": false
}
